import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import your translation files
import enTranslation from './translations/en.json';
import esTranslation from './translations/es.json';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslation,
      },
      es: {
        translation: esTranslation,
      },
    },
    fallbackLng: 'en',
    detection: {
      order: ['querystring', 'cookie'],
      caches: ['cookie'], // Note the change from `cache` to `caches`
    },
    interpolation: {
      escapeValue: false, // React already escapes by default
    },
  });

export default i18n;
